<template>
  <div class="layout-topbar sm:flex">
    <div class="mb-3 sm:mb-0">
      <span class="mx-2">
        <span class="font-bold capitalize">{{ title }}</span>
      </span>
      <Button
        v-for="locale in $i18n.availableLocales"
        :key="`locale-${locale}`"
        :label="locale"
        class="button-text mx-2"
        :class="$i18n.locale == locale ? '' : 'button-plain'"
        @click="switchLocale(locale)"
      />
    </div>

    <div class="layout-topbar-icons top-icons">
      <Button
        link
        v-tooltip.bottom="'Invoices - To Be Approved'"
        @click="loadInvoiceListing($event, 'op-invoices')"
      >
        <span class="layout-topbar-item-text text-lg"
          >Invoices (Waiting for approval)</span
        >

        <span class="layout-topbar-icon pi pi-receipt p-overlay-badge">
          <Badge
            severity="success"
            v-if="tbaInvoicesTotal > 0"
            :value="tbaInvoicesTotal"
          />
        </span>
      </Button>
      <Button
        link
        v-tooltip.bottom="'Notifiation'"
        @click="toggle($event, 'op-notifs')"
      >
        <span class="layout-topbar-item-text text-lg">Notifiation</span>

        <span class="layout-topbar-icon pi pi-bell p-overlay-badge">
          <Badge
            severity="success"
            v-if="notifications && notifications.length > 0"
            :value="notifications.length"
          />
        </span>

        <OverlayPanel class="notif-scroll" ref="op-notifs">
          <div class="flex justify-content-between flex-wrap p-2">
            <h3 class="mt-0 p-0">Notifications</h3>
            <Badge
              severity="success"
              v-if="notifications && notifications.length > 0"
              :value="notifications.length"
            >
            </Badge>
            <Divider class="m-0" />
          </div>
          <ScrollPanel style="width: 100%; max-height: 200px">
            <Button
              link
              class="flex flex-wrap flex-grow-12 p-2 px-3 align-items-center gap-3 w-full"
              v-for="(item, index) in notifications"
              :key="index"
              @click="openNotificationButton(item)"
            >
              <Avatar
                :label="core.getInitials(item.userName)"
                class="shadow-2 flex-shrink-0"
                size="large"
                :style="{
                  backgroundColor: core.stringToColor(item.userName),
                  color: '#ffffff',
                }"
                shape="circle"
                v-tooltip="item.userName"
              />

              <div text class="flex-grow-1 flex flex-column gap-2">
                <span v-if="item.action['msg']" class="font-bold"
                  >{{ item.userName }} {{ item.action.msg }}</span
                >
                <span class="text-black" v-if="item.action['item']">{{
                  item.action.item.display_name || item.action.item.title
                }}</span>
                <div
                  class="flex align-items-center justify-content-between flex-wrap gap-2"
                >
                  <div>
                    <i class="pi pi-clock text-sm mr-2"></i>
                    <span>{{ core.parseDateTime(item.created_at) }}</span>
                  </div>
                  <Button
                    icon="pi pi-check"
                    text
                    rounded
                    aria-label="Mark As Read"
                    v-tooltip="'Mark As Read'"
                  />
                </div>
              </div>
              <Divider class="m-0" v-if="notifications.length - 1 != index" />
            </Button>
          </ScrollPanel>
        </OverlayPanel>
      </Button>

      <Button v-tooltip.bottom="'Support'" link>
        <span class="layout-topbar-item-text">Support</span>
        <span class="layout-topbar-icon pi pi-question-circle" />
      </Button>
      <Button link v-tooltip.bottom="'Company Settings'" @click="openSettings">
        <span class="layout-topbar-item-text">Settings</span>
        <span class="layout-topbar-icon pi pi-cog" />
      </Button>
      <Button v-tooltip.bottom="'Switch..'" link>
        <span class="layout-topbar-item-text">Switch</span>
        <span class="layout-topbar-icon pi pi-clone" />
      </Button>
      <Button link v-tooltip.bottom="'Home Page'" @click="home">
        <span class="layout-topbar-item-text">Home</span>
        <span class="layout-topbar-icon pi pi-home" />
      </Button>
      <Button
        severity="danger"
        link
        v-tooltip.bottom="'Sign-Out'"
        @click="logout"
      >
        <span class="layout-topbar-item-text">Sign-Out</span>
        <span class="layout-topbar-icon pi pi-sign-out text-yellow-600" />
      </Button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AuthService from "@/services/auth.service";
import InvoicesService from "@/services/invoice.service";
import { Core } from "@/helpers/core";
import { Money } from "@/helpers/money";
import SettingsService from "../services/settings.service";
export default {
  data() {
    let invService = new InvoicesService();
    return {
      services: {
        invoice: invService,
      },
      Money: Money,
      core: Core,
      userName: null,
      notifications: [],
      tbaInvoicesTotal: null,
    };
  },
  mounted() {
    this.loadTerminologies();
    this.getname();
    this.switchLocale("en");
    this.checkNotification();
    this.loadTBAInvoicesTotal();
    this.emitter.on("refresh-tba-count", this.loadTBAInvoicesTotal);
  },
  beforeUnmount() {
    this.emitter.off("refresh-tba-count", this.loadTBAInvoicesTotal);
  },
  methods: {
    ...mapActions("fetch", ["fetch"]),
    ...mapActions("terminology", ["update"]),
    loadTerminologies() {
      let settingsService = new SettingsService();
      settingsService.get(null, "/defaults").then((res) => {
        this.filteredItems = res.terminologies;

        for (let item of this.filteredItems) {
          this.update({ domain: "employee", info: item.terminology });
        }
      });
    },
    checkNotification() {
      let authService = new AuthService();
      authService.notifications().then((response) => {
        this.notifications = response.items;
      });
    },

    loadTBAInvoicesTotal() {
      this.services.invoice.loadTBAInvoices().then((response) => {
        this.tbaInvoicesTotal = response;
      });
    },
    switchLocale(locale) {
      this.$root.$i18n.locale = locale;
    },
    addgems() {
      this.emitter.emit("add-gem", { tab_id: this.$route.params.tab_id });
    },
    collapseAll() {
      this.emitter.emit("collapse-gem");
    },
    expandAll() {
      this.emitter.emit("expand-gem");
    },
    logout(event) {
      this.$store.dispatch("auth/logout");
      this.$emit("logout", event);
      this.$router.push("login");
    },
    home() {
      this.$router.push("/");
    },

    getname() {
      this.userName = JSON.parse(localStorage.getItem("epicai.user"));
    },
    openSettings() {
      this.emitter.emit("open-gem", {
        item: {
          key: "listView",
          label: "Configuration and Settings",
          service: -10,
        },
      });
    },
    openNotificationButton(item) {
      this.emitter.emit("open-gem", {
        item: {
          key: "detail",
          label: "Notifications",
          service: -73,
          item: item,
        },
      });
    },
    loadInvoiceListing() {
      this.services.invoice
        .get({ is_tba: 1, status: 1, sort: "-id", page: 1, rows: 500 })
        .then((data) => {
          const items = (data.items || []).filter((row) => row.id);
          if (!items.length) {
            this.$confirm.require({
              message: "There are no invoices waiting for approval.",
              dialogType: "warning",
              showReject: false,
              accept: () => {},
            });
            return;
          }
          this.emitter.emit("open-gem", {
            item: {
              key: "detail",
              label: "Invoices - To Be Approved",
              isVisible: true,
              service: this.services.invoice.DOMAIN,
              item: items[0],
              previewItems: items,
              previewIndex: 0,
            },
          });
        });
    },

    toggle(event, menu) {
      this.$refs[menu].toggle(event);
    },
  },
};
</script>

<!-- key: "loader",
label: "Users",
service: 89, -->
